import MiniFooter from './MiniFooterComponent';
export default MiniFooter;
